export default "__VITE_ASSET__LqnTCOIx__"